import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopNotificationComponent } from './top-notification.component';

@NgModule({
  imports: [CommonModule],
  declarations: [TopNotificationComponent],
  exports: [TopNotificationComponent],
})
export class TopNotificationModule {}
